import styled from 'styled-components';
import { Div } from 'styles/elements/div';
import { HOME_BUTTON_MARGIN } from './button';

export const ButtonContainer = styled(Div)`
  flex-wrap: wrap;
  margin: 0 -${HOME_BUTTON_MARGIN}px;
`;
